let forms = {
	login: {
		icon: 'fa fa-user',
		title: 'Log In',
		subtitle: 'Log In to the System',
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'username',
				validation: 'required|min:3|max:150',
				label: 'Email or Username',
				placeholder: 'Enter the username',
			},
			{
				type: 'text',
				form_type: 'password',
				class: 'col-12',
				model: 'password',
				validation: 'required|min:3|max:150',
				label: 'Password',
				placeholder: 'Enter the password',
			},
			{
				type: 'checkbox',
				class: 'col-12 custom-check',
				model: 'trust',
				validation: '',
				label: 'Trust this device?',
			},
		],
	},
	send_otp: {
		icon: 'fa fa-user',
		title: 'Log In',
		subtitle: 'Log In to the System',
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'email',
				validation: 'required|min:3|max:150',
				label: 'Email or Phone Number',
				placeholder: 'Enter your Email or Phone Number',
			},
		],
	},
	validate_otp: {
		icon: 'fa fa-user',
		title: 'Log In',
		subtitle: 'Log In to the System',
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'big-input col-12',
				model: 'otp',
				validation: 'required|min:4|max:6',
				label: 'OTP Received on phone or email',
			},
		],
	},
	reset_password: {
		icon: 'fa fa-user',
		title: 'Log In',
		subtitle: 'Log In to the System',
		forms: [
			{
				type: 'text',
				form_type: 'password',
				class: 'custom-input col-12',
				model: 'new_password',
				validation: 'required|min:3|max:150',
				label: 'New Password',
			},
			{
				type: 'text',
				form_type: 'password',
				class: 'custom-input col-12',
				model: 'confirmPassword',
				validation: 'required|min:3|max:150',
				label: 'Confirm Password',
			},
		],
	},
};

module.exports = {
	forms: utils.generateAllFormData(forms),
};
